(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    

const sectionContainer = document.querySelector('.product__info');

sectionContainer.addEventListener('click', function(event) {
  const reviewWidget = event.target.closest('.ryviu-collection, ryviu-widget-total');
    
  if (reviewWidget) {
    
    getScrollableTabs();
  }
});

function getScrollableTabs () {
    const tabs = document.querySelector('.tabs-nav__item-list');
    const productTabsContents = document.querySelector('.product-tabs__content');

    const reviewButton = tabs.children[1];

    reviewButton.click();
    productTabsContents.scrollIntoView({behavior: "smooth", block:"start"});    
    
}

  } catch(e) { console.error(e); }
})();
})();
